import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';

export default class ProductVersionApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  public getProductVersionDiff(current: any, request: any, params: any = {}) {
    const query = `/core/v4/service-product/productversion/diff${qs.stringify(
      params,
      true,
    )}`;
    return this.post(query, {
      current,
      request,
    });
  }
}
